import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, GetReverReturnInfoSchema, GetReveniReturnResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof GetReveniReturnResponseDataSchema>>

export function useReverSearchReturnMutation() {
  return useMutation({
    mutationFn: async (data: z.infer<typeof GetReverReturnInfoSchema>) => {
      return axios
        .post<Response>(`/integrations/rever/search`, data)
        .then((response) => response.data.data)
    },
  })
}
